import { render } from "./AdditionalFilesModal.vue?vue&type=template&id=175691fe&scoped=true"
import script from "./AdditionalFilesModal.vue?vue&type=script&lang=js"
export * from "./AdditionalFilesModal.vue?vue&type=script&lang=js"

import "./AdditionalFilesModal.vue?vue&type=style&index=0&id=175691fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-175691fe"]])

export default __exports__